<template>
  <div class="talk-part">
    <div class="zan-cai-date clearfix">
      <div class="zan-cai">
        <div class="item" @click="share">
          <span class="zc-icon zhuanfa"></span>
          <span class="count">200</span>
        </div>
        <div class="item">
          <span class="zc-icon zan"></span>
          <span class="count">200</span>
        </div>
        <div class="item">
          <span class="zc-icon shoucang"></span>
          <span class="count">200</span>
        </div>
        <div class="item" @click="pinglunEvent">
          <span class="zc-icon pinglun"></span>
          <span class="count">200</span>
        </div>
        <div class="item more">
          <el-dropdown>
            <span class="el-dropdown-link count"><i class="el-icon-more"></i></span>
            <el-dropdown-menu slot="dropdown">
              <span @click="jubao"><el-dropdown-item>举报</el-dropdown-item></span>
              <el-dropdown-item>拉黑</el-dropdown-item>
              <el-dropdown-item>编辑</el-dropdown-item>
              <el-dropdown-item>删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <template v-if="showFirPL">
      <div class="console-ipt">
        <el-input
          class="textarea"
          type="textarea"
          :rows="1"
          placeholder="请输入内容"
          v-model="textCon"
        >
        </el-input>
        <div class="checked-btn clearfix">
          <el-button class="fabu-btn" type="primary" size="mini">提交</el-button>
        </div>
      </div>
      
      <div class="pinglun-list">
        <div class="pl-list">
          <ans-user />
          <ans-user />
        </div>
      </div>

      


    </template>
    <!-- 分享弹窗 -->
    <el-dialog
      title="分享到"
      class="common-dialog"
      :visible.sync="dialogVisibleShare"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      append-to-body
    >
      <ul class="dialog-share-list clearfix">
        <li>
          <div class="img-f">
            <img :src="require('@/assets/images/share_01.png')" alt="">
          </div>
          <p>我的动态</p>
        </li>
        <li @click="shareWechat">
          <div class="img-f">
            <img :src="require('@/assets/images/share_02.png')" alt="">
          </div>
          <p>微信</p>
        </li>
        <li @click="shareWeibo">
          <div class="img-f">
            <img :src="require('@/assets/images/share_03.png')" alt="">
          </div>
          <p>微博</p>
        </li>
        <li @click="shareQQzone">
          <div class="img-f">
            <img :src="require('@/assets/images/share_04.png')" alt="">
          </div>
          <p>QQ空间</p>
        </li>
        <li>
          <div class="img-f">
            <img :src="require('@/assets/images/share_05.png')" alt="">
          </div>
          <p>生成海报</p>
        </li>
        <li @click="copyLink">
          <div class="img-f">
            <img :src="require('@/assets/images/share_06.png')" alt="">
          </div>
          <p>复制链接</p>
        </li>
        <!-- <li>
          <div class="img-f">
            <img :src="require('@/assets/images/share_01.png')" alt="">
          </div>
          <p>收藏</p>
        </li> -->
      </ul>
      <el-dialog
        title="分享到微信"
        class="common-dialog"
        :visible.sync="dialogVisibleShareWechat"
        :close-on-click-modal="false"
        append-to-body
      >
        <div ref="qrcode" class="dialog-share-wechat"></div>
      </el-dialog>
    </el-dialog>
    <!-- 举报 -->
    <el-dialog
      title="举报理由"
      class="common-dialog"
      :visible.sync="dialogVisibleJubao"
      :close-on-click-modal="false"
    >
      <div class="dialog-jubao-cont">
        <el-checkbox-group v-model="jubaolist">
          <el-checkbox label="侵犯版权"></el-checkbox>
          <el-checkbox label="内容低俗"></el-checkbox>
          <el-checkbox label="恶意灌水"></el-checkbox>
          <el-checkbox label="其他"></el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleJubao = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import QRCode from 'qrcodejs2'
import ansUser from './ansUser'

export default {
  components: {
    ansUser
  },
  data () {
    return {
      showFirPL: false,
      textCon: '',
      dialogVisibleShare: false,
      dialogVisibleShareWechat: false,
      dialogVisibleJubao: false,
      jubaolist: []
    }
  },
  methods: {
    pinglunEvent () {
      this.showFirPL = !this.showFirPL
    },
    share () {
      this.dialogVisibleShare = true
    },
    jubao () {
      this.dialogVisibleJubao = true
    },
    shareWechat () {
      this.dialogVisibleShareWechat = true
      this.$nextTick(() => {
        new QRCode(this.$refs.qrcode, {
          width: 100,
          height: 100,
          text: 'http://www.baidu.com'
        })
      })
    },
    shareWeibo () {
      const url = 'http%3A%2F%2Fwww.wemeie.com%2F%23%2FcourseDetail%3FcourseId%3D2160'
      const title = '%E5%B0%8F%E7%8F%AD%E8%AF%BE'
      const pic = 'http%3A%2F%2Focs.21teacher.com%2Fdir-image%2F2019%2F12%2F31%2F69e73bac81a64b94b840ade2e2a2f37c.gif'
      const appkey = '#_loginLayer_1578022321857'
      const link = `http://service.weibo.com/share/share.php?url=${url}&title=${title}&pic=${pic}&appkey=${appkey}`
      window.open(link)
    },
    shareQQzone () {
      const url = 'http%3A%2F%2Fwww.wemeie.com%2F%23%2FcourseDetail%3FcourseId%3D2160'
      const title = '%E5%B0%8F%E7%8F%AD%E8%AF%BE'
      const desc = ''
      const summary = ''
      const site = '%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83'
      const link = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${desc}&summary=${summary}&site=${site}`
      window.open(link)
    },
    copyLink () {
      
    }
  }
}
</script>

<style scoped lang="less">
.console-ipt{
  margin-top: 10px;
}
</style>
